import { useMemo } from 'react'

import './styles/modal-import-accept.scss'

interface Props {
    data: any,
    categories: any[],
}

export default function ModalImportAccept({data, categories}: Props) {
    const categoriesToString = useMemo(() => {
        const list = categories.filter((category) => {
            if(data.categories.includes(category.id)) {
                return category.title
            }
        })

        return list.map((item) => item.title).join(', ')
    }, [data])

    return (
        <div className="modal-import-accept">
            <ul className={"modal-import-accept__list"}>
                <li className={"modal-import-accept__list-item"}>
                    <div>
                        <span className={"modal-import-accept__option-name"}>Название:</span>
                    </div>
                    <span className={"modal-import-accept__option-value"}>{ data.name }</span>
                </li>
                <li className={"modal-import-accept__list-item"}>
                    <div>
                        <span className={"modal-import-accept__option-name"}>Описание:</span>
                    </div>

                    <span className={"modal-import-accept__option-value"}>{ data.description }</span>
                </li>
                <li className={"modal-import-accept__list-item"}>
                    <div>
                        <span className={"modal-import-accept__option-name"}>Год:</span>
                    </div>

                    <span className={"modal-import-accept__option-value"}>{ data.release_year }</span>
                </li>
                <li className={"modal-import-accept__list-item"}>
                    <div>
                        <span className={"modal-import-accept__option-name"}>Категории:</span>
                    </div>

                    <span className={"modal-import-accept__option-value"}>{ categoriesToString }</span>
                </li>
                <li className={"modal-import-accept__list-item"}>
                    <div>
                        <span className={"modal-import-accept__option-name"}>Рейтинг:</span>
                    </div>

                    <span className={"modal-import-accept__option-value"}>{ data.rating }</span>
                </li>
            </ul>
        </div>
    )
}